import React from 'react';
import ButtonLink from '../../Form/ButtonLink';
import { TbPencil } from 'react-icons/tb';
import { ImSpinner8 } from 'react-icons/im';
import { useTranslation } from 'react-i18next';

interface BoxContentConfirmTableProps {
  show: boolean;
  loading: boolean;
  onClickConfirm: CallableFunction;
  tableName: string;
}

const BoxContentConfirmTable = ({
  show,
  loading,
  onClickConfirm,
  tableName,
}: BoxContentConfirmTableProps) => {

  const { t } = useTranslation();

    if (!show) return null;
    return (
    <div className='grid gap-3 rounded-t-2xl p-4 pb-1 shadow-reverse-md'>
        <div className='text-center font-bold text-lg leading-none'>{t('store_counter.table_choice.confirm_table_title')}</div>
        <div className='flex items-center justify-center gap-2 text-center'>
            <hr className='w-full border-sky-100' />
            <ButtonLink className={`text-nowrap animate-fade-in ${loading ? 'text-xl gap-1 pointer-events-none' : 'text-2xl gap-0.5'}`} onClick={() => onClickConfirm()}>
                {loading 
                  ? <><span><ImSpinner8 className="animate-spin" /></span><span className='font-extrabold'>{t('store_counter.table_choice.checking_table')}</span></>
                  : <><span><TbPencil /></span><span className='font-extrabold'>{ tableName }</span></>
                }
            </ButtonLink>
            <hr className='w-full border-sky-100' />
        </div>
        <div className='grid w-full text-center gap-1 text-sm'>
            <span className='text-gray-500 font-bold leading-none'>{t('store_counter.table_choice.text_change_1')}</span>
            <span className='text-gray-400 leading-none'>{t('store_counter.table_choice.text_change_2')}</span>
        </div>
    </div>
  )
}

export default BoxContentConfirmTable;